import Dashboard from "./Dashboard";
export default function DashboardCollabRequest() {
  return <Dashboard mode="collab" />;
}
